export default {"src":"/_next/static/media/getpacked.ff09e146.svg","height":32,"width":37};